import { useSelector } from 'react-redux';
import { RootState } from '../redux/rootReducer'
import { BookDb } from '../redux/bookDbSlice'

const useCurrentBookDb = () : BookDb | undefined => {
  const bookDb = useSelector((state: RootState) => state.bookDb)
  if (bookDb.currentBookId) {
    const bookId = bookDb.currentBookId
    const bookValue = bookDb.books[bookId]
    return bookValue
  } else {
    return undefined
  }
}

export default useCurrentBookDb